import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { CONTACT } from '../mock/data';

const STORAGE_KEY = 'vivamore_promo_seen';

function shouldShow() {
  try {
    return window.location.pathname === '/' && !sessionStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return false;
  }
}

export default function PromoPopup() {
  const location = useLocation();
  // Open immediately on first render when on home & not seen this session
  const [open, setOpen] = useState(() => shouldShow());

  // Re-evaluate when navigating back to home within the same session
  useEffect(() => {
    if (location.pathname === '/' && !sessionStorage.getItem(STORAGE_KEY)) {
      setOpen(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const close = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* ignore */
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 sm:p-6">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-ink/80 backdrop-blur-sm animate-fade-in"
        onClick={close}
      />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-4xl bg-cream shadow-2xl overflow-hidden flex flex-col md:flex-row animate-fade-up max-h-[92vh]">
        {/* Close */}
        <button
          onClick={close}
          aria-label="Close promotion"
          className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-ink/50 hover:bg-ink text-cream flex items-center justify-center transition-colors"
        >
          <X size={20} />
        </button>

        {/* Left: poster */}
        <div className="md:w-1/2 shrink-0">
          <img
            src="/promo/lunch-set.webp"
            alt="Unlimited Drink of the Day with Special Lunch Set — RM25+"
            className="w-full h-52 md:h-full object-cover object-top"
          />
        </div>

        {/* Right: details */}
        <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center overflow-y-auto">
          <div className="gold-line mb-6" />
          <span className="text-xs tracking-luxe uppercase text-gold">Exclusive Promotion</span>
          <h2 className="font-display text-4xl md:text-5xl text-ink mt-4 leading-tight">
            Special Lunch Set
          </h2>
          <p className="text-ink/70 font-light leading-relaxed mt-5">
            Enjoy unlimited drink of the day with every purchase of our Special Lunch Set.
            Includes soup of the day and choice of main course.
          </p>

          <div className="border border-ink/15 bg-white/60 p-6 mt-8">
            <p className="text-xs tracking-luxe uppercase text-ink/40">Current Offer</p>
            <p className="font-display text-3xl text-gold mt-2">RM25+</p>
          </div>

          <a
            href={CONTACT.whatsappReserve}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
            className="btn-gold mt-8 w-full text-center text-xs tracking-widest uppercase px-8 py-4 bg-gold text-cream border border-gold hover:bg-ink hover:border-ink"
          >
            Reserve A Table
          </a>

          <p className="text-[11px] text-ink/40 mt-4 leading-relaxed">
            Mon – Fri · 12:00 PM – 3:00 PM · Dine-in only. *T&amp;C applied. Price subject to 10% service charge.
          </p>
        </div>
      </div>
    </div>
  );
}
